import React from 'react';
import { Box, Inscription } from '@common-fe/common-fe';

import { SYNC_UPDATES_WARNING_TEXT } from './SyncUpdatesModal.constants';

export const SyncUpdatesPropertyWarningBanner = () => {
  return (
    <Box
      border={{ color: 'warningBorder', size: 'small' }}
      round="container2Round"
      align="center"
      background="warningContainer"
      pad={{ vertical: 'spacing12', horizontal: 'spacing16' }}
      width="100%"
      style={{ position: 'relative' }}
      data-testid="SyncUpdatesPropertyWarningBanner"
    >
      <Box
        round="smallRound"
        height="2px"
        background="warning"
        width="calc(100% - 32px)"
        style={{ top: '-1px', position: 'absolute' }}
      />
      <Box direction="row" align="center">
        <Inscription
          color="textBody"
          lineHeight="20px"
          data-testid="SyncUpdatesPropertyWarningBanner-description"
        >
          {SYNC_UPDATES_WARNING_TEXT}
        </Inscription>
      </Box>
    </Box>
  );
};
